<template>
  <div style="position: relative">
    <div id="anchor-container" class="anchor-container2" style="text-align: left;padding-left: 20px;padding-right: 260px;">
      <div style="font-size: 32px; margin-bottom: 15px;">使用前必读</div>
      <div style="font-size: 16px;margin-bottom: 30px;">软件依赖的系统环境、软件版本要求，以及使用规则。</div>
      <div>
        <div id="top1" class="text-title">软件版本要求</div>
        <p>系统版本：Windows10/11 64位；.net framework 4.0 以上。</p>
        <p>office版本：V16.0（office word 2016 /365）<a href="#b3">(如已有或安装WPS，查看注意事项）。</a></p>
        <p>Acrobat版本：<span class="text-red">Adobe Acrobat DC 32位</span> <a href="http://www.booleanda.cc:9600" target="_blank">(前往下载破解版2020）。</a></p>
      </div>
      <div>
        <div id="top2" class="text-title">前序配置</div>
        <p> 在使用前，请按《代码使用注意事项.docx》做好文件配置，相关的资源文件不要删除。</p>
        <p>设置doc/docx文件类型打开方式默认为word，设置pdf文件类型打开方式默认为Acrobat DC。<span class="text-red">如装有WPS软件或新安装WPS，请务必按注意事项安装
        </span>。<a href="http://www.booleanda.cc:9600" target="_blank">（点击下载EXCEL版本）</a></p>
        <p><span class="text-red">同时，在运行代码时，不要打开使用word和Acrobat软件。</span> </p>
        <p>运行中如需强制退出，按Ctrl+Alt+Delete键【任务管理器】—找到进程【word2pdf.exe】/【Adobe Acrobat DC 32位】—结束进程。 </p>
      </div>
      <div>
        <div id="top3" class="text-title">使用约定</div>
        <p>本软件可申请免费试用一个月。其中，激活码验证版本可支持离线/内网环境使用。 </p>
        <p>账号在验证后，<span class="text-red">仅可在首次验证登录的机器使用，一机一码，暂无法在其他电脑上使用。</span>  </p>
        <p>软件依赖于本地电脑的office 16/Adobe Acrobat DC软件实现，所有文档操作均在本地电脑进行，联网仅执行账号验证，不会收集任何文档信息，确保文档信息安全。</p>
      </div>
      <div style="text-align: right;color: #919191;font-size: 14px;margin-top: 80px">上次更新：2023-7-14</div>
      <el-divider></el-divider>
      <div class="box">
        <div class="box-left"><el-button type="text" icon="el-icon-arrow-left">左侧按钮</el-button></div>
        <div class="box-right"><el-button type="text">右侧按钮<i class="el-icon-arrow-right el-icon--right"></i></el-button></div>
      </div>
      <div style="height: 400px"></div>
    </div>
    <div style="display: flex;position: absolute;top:100px;right: 40px" class="anchor">
      <div style="flex: 1"></div>
      <t-anchor :affix-props="{ offsetTop: 50}" :bounds="150" container="#anchor-container" @click="handleClick">
        <t-anchor-item href="#top1" class="anchor-content-1" title="软件版本要求"></t-anchor-item>
        <t-anchor-item href="#top2" class="anchor-content-2" title="前序配置"></t-anchor-item>
        <t-anchor-item href="#top3" class="anchor-content-3" title="使用约定" />
      </t-anchor>
    </div>
    <el-backtop target=".anchor-container2" right="60" bottom="80"></el-backtop>
  </div>
</template>

<script>
import { Anchor } from 'tdesign-vue'
import { AnchorItem } from 'tdesign-vue'
// 引入组件库的少量全局样式变量
import 'tdesign-vue/es/style/index.css'
export default {
  name: 'Test',
  components: {
    tAnchor: Anchor,
    tAnchorItem: AnchorItem
    // FixedHeader
  },
  data() {
    return {
      tableData: []
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleClick({ e, href, title }) {
      e.preventDefault()
      console.log('click', href, title)
    }
  }
}
</script>

<style lang="scss" scoped>
h4{
  border-left: 5px solid #409EFF;
  padding-left: 10px;
}
p::before {
  content: "\2022"; /* 使用Unicode编码，表示为圆点 */
  margin-right: 0.5em;
  color: #494949;
  font-size: 1.2em;
}
#anchor-container {
  flex-grow: 1;
  height: 800px;
  //overflow: auto;
  position: relative;
  overflow-y: scroll;
  color: #5d5c5c;
  > div {
    //text-align: center;
    //font-size: 22px;
    //line-height: 100px;
  }
}
#anchor-container::-webkit-scrollbar {
  width: 5px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
}
#anchor-container::-webkit-scrollbar-track {
  box-shadow: 0px 1px 3px #FFFFFF inset; /*滚动条的背景区域的内阴影*/
  border-radius: 10px; /*滚动条的背景区域的圆角*/
  background-color: #FFFFFF; /*滚动条的背景颜色*/
}
#anchor-container::-webkit-scrollbar-thumb {
  box-shadow: 0px 1px 3px #e3e4e5 inset; /*滚动条的内阴影*/
  border-radius: 10px; /*滚动条的圆角*/
  background-color: #e3e4e5; /*滚动条的背景颜色*/
}
.text-title{
  font-size: 22px;
  margin-top: 60px;
  margin-bottom: 25px;
  border-left: 5px solid #409EFF;
  padding-left: 10px;
}
.text-image {
  width: 600px;
  height: 350px;
}

.text-red {
  color: #5d5c5c;
  font-stretch: normal;
  font-weight: bold;
}

.header {
  background-color: #f1f1f1;
  padding: 20px;
  text-align: center;
  height: 25px;
}

.menu {
  padding: 1px 10px;
  background-color: #f1f1f1;
}

.content {
  margin-left: 15%;
  padding: 1px 16px;
}
.box{
  display: flex;
  justify-content: space-between;
}
.box-left{
  width: 48%;
}
.box-right{
  width: 48%;
  text-align: right;
}
// 修改锚点的颜色
.anchor{
  --td-text-color-primary:#5d5c5c !important;
  // 激活颜色
  --td-brand-color:#409EFF !important;
}
a{
  // 取消下划线
  text-decoration: none;
}
a:link {
  color: #409EFF;
  text-underline: #FFFFFF;
}
a:hover {
  color: #99c9fa;
}
a:visited{
  color: #409EFF;
}
</style>
